import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { SurfaceModule } from "@storeblocks/surface-ng";

@Component({
  selector: "app-card",
  standalone: true,
  imports: [SurfaceModule],
  templateUrl: "./card.component.html",
  styleUrl: "./card.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  readonly customClass = input("");
  readonly size = input<"small" | "medium" | "large">("medium");
  readonly background = input<"surface-1" | "surface-2" | "background">("surface-1");
  readonly hasBorder = input(false);
}
